module.exports = __webpack_public_path__ + "assets/img/img-douyin-23ad3ebb.png";